import React from "react";
import {
  Box,
  Chip,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { formatStatValue } from "../../../utils/triviaArcade";

const findPlayerLabel = (question, playerId) => {
  const match = question?.options?.find((option) => option.playerId === playerId);
  return match?.displayName || match?.text || playerId;
};

const DEFINITIONS = [
  { label: "Ranks", read: (inspector) => (inspector.ranks || []).join(", ") },
  { label: "Gap", read: (inspector) => inspector.gap },
  { label: "Threshold", read: (inspector) => inspector.threshold },
];

const TriviaInspector = ({ question }) => {
  const inspector = question?.inspector;

  if (!inspector) {
    return <Typography color="text.secondary">Select a question</Typography>;
  }

  return (
    <Stack spacing={2}>
      <Typography
        variant="body2"
        sx={{ fontFamily: "monospace", wordBreak: "break-all" }}
      >
        {inspector.fingerprint}
      </Typography>

      <Box
        component="dl"
        sx={{
          display: "grid",
          gridTemplateColumns: "auto 1fr",
          columnGap: 2,
          rowGap: 0.5,
          m: 0,
        }}
      >
        {DEFINITIONS.map(({ label, read }) => {
          const value = read(inspector);
          return (
            <React.Fragment key={label}>
              <Typography component="dt" variant="body2" color="text.secondary">
                {label}
              </Typography>
              <Typography component="dd" variant="body2" sx={{ m: 0 }}>
                {value === null || value === undefined || value === ""
                  ? "n/a"
                  : value}
              </Typography>
            </React.Fragment>
          );
        })}
      </Box>

      {(inspector.presetKeys || []).length > 0 && (
        <Stack direction="row" spacing={0.5} sx={{ flexWrap: "wrap", rowGap: 0.5 }}>
          {inspector.presetKeys.map((presetKey) => (
            <Chip key={presetKey} size="small" variant="outlined" label={presetKey} />
          ))}
        </Stack>
      )}

      <Table size="small" aria-label="Inspector player stats">
        <TableHead>
          <TableRow>
            <TableCell>Player</TableCell>
            <TableCell align="right">Rank</TableCell>
            <TableCell align="right">Stat</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(inspector.stats || []).map((stat) => (
            <TableRow key={stat.playerId}>
              <TableCell>{findPlayerLabel(question, stat.playerId)}</TableCell>
              <TableCell align="right">{stat.rank}</TableCell>
              <TableCell align="right">
                {formatStatValue(question.subcategory, stat.statValue)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Stack>
  );
};

export default TriviaInspector;
